"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const ClusterDetails_1 = tslib_1.__importDefault(require("./ClusterDetails"));
const NewClusterWizard = () => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('pf-v5-c-wizard', 'cluster-wizard') },
        react_1.default.createElement(ClusterDetails_1.default, null)));
};
exports.default = NewClusterWizard;
//# sourceMappingURL=NewClusterWizard.js.map